import { all, call, fork, put, take, takeLatest } from 'redux-saga/effects'
import qs from 'qs'

import { createVisibilityChannel } from './visibilityChannel'
import { authSagas } from './auth'
import { customFollowUpLabelsSagas } from './customFollowUpLabels'
import { dashboardSagas } from './dashboard'
import { dataExtractRequestSagas } from './dataExtractRequest'
import { enrolmentsSagas } from './enrolments'
import { enrolmentEntitlementsSagas } from './enrolmentEntitlements'
import { enrolmentDraftSagas } from './enrolmentDraft'
import { globalNotificationSagas } from './globalNotification'
import { membershipsSagas } from './memberships'
import { organisationsSagas } from './organisations'
import { grantedOrganisationsSagas } from './grantedOrganisations'
import { participantsSagas } from './participants'
import { programEventsSagas } from './programEvents'
import { reportSagas } from './report'
import { reportsSagas } from './reports'
import { reportsOverviewSagas } from './reportsOverview'
import { requestSagas } from './request'
import { roundEnrolmentSagas } from './roundEnrolment'
import { roundEnrolmentsSagas } from './roundEnrolments'
import { roundEnrolmentsOverviewSagas } from './roundEnrolmentsOverview'
import { reportAnalyticsDetailsSagas } from './reportAnalyticsDetails'
import { notificationPreferenceSagas } from './notificationPreference'
import { calendarPreferenceSagas } from './calendarPreference'
import { generalPreferenceSagas } from './generalPreference'
import { accountPreferenceSagas } from './accountPreference'
import { systemStatusSagas } from './api'
import * as rootActions from './rootActions'
import * as authActions from './auth/actions'
import * as APIActions from './api/actions'

export function* appInitialization(action: any): Generator<any, any, any> {
  const query = qs.parse(window.location.search.substring(1))
  const redirect = query.redirect
  const notification = query.notification

  if (query.token) {
// @ts-expect-error - TS2322 - Type 'string | string[] | ParsedQs | ParsedQs[]' is not assignable to type 'string'.
    yield put(authActions.jwtAuth({ token: query.token }, redirect, notification))
  } else {
    yield put(APIActions.fetchApiSpecification())
  }
}

function* watchAppInitialization(): Generator<any, any, any> {
  yield takeLatest([
    rootActions.APP_INITIALIZATION
  ], appInitialization)
}

export function* watchAppVisibility() {
// @ts-expect-error - TS7057 - 'yield' expression implicitly results in an 'any' type because its containing generator lacks a return-type annotation.
  const channel = yield call(createVisibilityChannel)

  while (true) {
    yield take(channel)
    // Dispatch a Redux action whenever the user focuses the tab/wakes up
    yield put(rootActions.appBecameVisible())
  }
}

export default function* rootSaga(): Generator<any, any, any> {
  yield all([
    fork(watchAppInitialization),
    fork(watchAppVisibility),
    fork(authSagas),
    fork(customFollowUpLabelsSagas),
    fork(dashboardSagas),
    fork(dataExtractRequestSagas),
    fork(enrolmentsSagas),
    fork(enrolmentEntitlementsSagas),
    fork(enrolmentDraftSagas),
    fork(globalNotificationSagas),
    fork(membershipsSagas),
    fork(organisationsSagas),
    fork(grantedOrganisationsSagas),
    fork(participantsSagas),
    fork(programEventsSagas),
    fork(reportSagas),
    fork(reportsSagas),
    fork(reportsOverviewSagas),
    fork(requestSagas),
    fork(reportAnalyticsDetailsSagas),
    fork(roundEnrolmentSagas),
    fork(roundEnrolmentsSagas),
    fork(roundEnrolmentsOverviewSagas),
    fork(notificationPreferenceSagas),
    fork(calendarPreferenceSagas),
    fork(generalPreferenceSagas),
    fork(accountPreferenceSagas),
    fork((systemStatusSagas)),
  ])
}
